import { useRouter } from 'next/router';
import { useContext } from 'react';
import CheckoutContext from './checkoutContext';

export function usePartnerParams() {
  const router = useRouter();
  const { partnerId: partnerIdFromContext, donationProgramId: donationProgramIdFromContext } =
    useContext(CheckoutContext);

  let donationProgramId = donationProgramIdFromContext || router.query.donationProgramId;
  let partnerId = partnerIdFromContext || router.query.partnerId;

  if (donationProgramId && Array.isArray(donationProgramId)) {
    donationProgramId = donationProgramId[0];
  }

  if (partnerId && Array.isArray(partnerId)) {
    partnerId = partnerId[0];
  }

  return { donationProgramId, partnerId };
}
